import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="invoices--show-more"
export default class extends Controller {
  static targets = ["main", "section", "button", "buttonText", "icon", "showMoreState"]

  connect() {
    this.#initializeShowMoreButton()

    if (!this.showMore) {
      this.mainTarget.classList.toggle("mb-0")
    }
  }

  toggle() {
    this.#initializeShowMoreButton()
    this.sectionTargets.forEach((section, index) => {
      if (!this.showMore) {
        this.mainTarget.classList.add("mb-0")
      } else {
        this.mainTarget.classList.remove("mb-0")
      }
      section.classList.toggle("invoice__subsection--hidden")
      setTimeout(() => {
        section.classList.toggle("invoice__subsection--visible")
      }, index * 100)
    })
    this.showMoreStateTarget.value = this.showMore
    this.#updateUrl(this.showMore)
  }

  #initializeShowMoreButton() {
    this.showMore = this.showMore != null ? !this.showMore : this.showMoreStateTarget.value === "true"
    this.buttonTextTarget.textContent = this.showMore
      ? this.buttonTarget.dataset.hideText
      : this.buttonTarget.dataset.showText
    this.iconTarget.innerHTML = this.showMore
      ? '<span class="material-symbols-outlined">arrow_drop_up</span>'
      : '<span class="material-symbols-outlined">arrow_drop_down</span>'
  }

  #updateUrl(state) {
    const currentUrl = window.location.href
    const url = new URL(currentUrl)
    url.searchParams.set("show_more", state)
    window.history.replaceState({}, "", url)
  }
}
